import * as React from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { cn } from '@/lib/utils';

const EASE_OUT = 'cubic-bezier(0.23, 1, 0.32, 1)';

// Carrossel de conteúdo expositivo: 1 slide { title, body } por vez. Controlado por estado
// (botões + dots), sem dependência de layout externo — largura sempre a do container.
const ContentCarousel = ({ slides = [], className }) => {
  const [index, setIndex] = React.useState(0);
  const total = slides.length;

  if (total === 0) return null;

  const go = next => setIndex(Math.max(0, Math.min(total - 1, next)));
  const slide = slides[index];

  return (
    <div className={cn('mb-6 w-full min-w-0', className)}>
      <article
        key={index}
        style={{ animation: `trilha-in 320ms ${EASE_OUT} both` }}
        className="flex min-h-[340px] flex-col items-center justify-center rounded-2xl border border-solid border-neutral-100 bg-white p-8 text-center shadow-card"
      >
        <span
          className="mb-5 flex h-16 w-16 items-center justify-center rounded-full text-2xl font-extrabold text-primary-dark shadow-[0_6px_16px_rgba(249,145,83,0.35)]"
          style={{ background: 'var(--color-mission)' }}
        >
          {index + 1}
        </span>
        <h3 className="mb-3 text-xl font-bold text-primary-dark">{slide.title}</h3>
        <p className="mx-auto max-w-[52ch] whitespace-pre-line break-words text-base leading-relaxed text-neutral-darker">{slide.body}</p>
      </article>

      <div className="mt-4 flex items-center justify-between">
        <button
          type="button"
          onClick={() => go(index - 1)}
          disabled={index === 0}
          aria-label="Slide anterior"
          className="flex h-10 w-10 items-center justify-center rounded-full border border-solid border-primary-lightest bg-white text-primary shadow-dropshadow-sm transition-opacity disabled:cursor-default disabled:opacity-30"
        >
          <FiChevronLeft />
        </button>

        <div className="flex items-center gap-2">
          {slides.map((s, i) => (
            <button
              key={i}
              type="button"
              onClick={() => go(i)}
              aria-label={`Ir para o slide ${i + 1}`}
              className={cn('h-2 rounded-full transition-all duration-200', i === index ? 'w-5 bg-primary-light' : 'w-2 bg-gray-200 hover:bg-gray-300')}
            />
          ))}
        </div>

        <button
          type="button"
          onClick={() => go(index + 1)}
          disabled={index === total - 1}
          aria-label="Próximo slide"
          className="flex h-10 w-10 items-center justify-center rounded-full border border-solid border-primary-lightest bg-white text-primary shadow-dropshadow-sm transition-opacity disabled:cursor-default disabled:opacity-30"
        >
          <FiChevronRight />
        </button>
      </div>
    </div>
  );
};

export { ContentCarousel };
